import { DSButton } from "@components/design-system/molecules";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { useNavigate } from "react-router";

export function SoapEditButton({ note }) {
  const navigate = useNavigate();

  return (
    <DSButton
      title="Open note"
      icon={faArrowUpRightFromSquare}
      size="sm"
      variant="primary"
      onClick={() => {
        navigate(`/edit_note/${note?.uuid}`);
      }}
      dataTestId="edit-note-button"
    >
      Open Note
    </DSButton>
  );
}
